import { c as classNames } from '../../shared/bind-d9144132.js';
import { jsx } from 'react/jsx-runtime';

var styles = {
  "unit-base": "4",
  "x-small": "web_ui__Spacer__x-small",
  "small": "web_ui__Spacer__small",
  "regular": "web_ui__Spacer__regular",
  "medium": "web_ui__Spacer__medium",
  "large": "web_ui__Spacer__large",
  "larger": "web_ui__Spacer__larger",
  "x-large": "web_ui__Spacer__x-large",
  "x-larger": "web_ui__Spacer__x-larger",
  "x2-large": "web_ui__Spacer__x2-large",
  "x3-large": "web_ui__Spacer__x3-large",
  "x4-large": "web_ui__Spacer__x4-large",
  "x5-large": "web_ui__Spacer__x5-large",
  "x6-large": "web_ui__Spacer__x6-large",
  "vertical": "web_ui__Spacer__vertical",
  "horizontal": "web_ui__Spacer__horizontal"
};

var Size = /*#__PURE__*/function (Size) {
  Size["XSmall"] = "x-small";
  Size["Small"] = "small";
  Size["Regular"] = "regular";
  Size["Medium"] = "medium";
  Size["Large"] = "large";
  Size["Larger"] = "larger";
  Size["XLarge"] = "x-large";
  Size["XLarger"] = "x-larger";
  Size["X2Large"] = "x2-large";
  Size["X3Large"] = "x3-large";
  Size["X4Large"] = "x4-large";
  Size["X5Large"] = "x5-large";
  Size["X6Large"] = "x6-large";
  return Size;
}(Size || {});
var Orientation = /*#__PURE__*/function (Orientation) {
  Orientation["Horizontal"] = "horizontal";
  Orientation["Vertical"] = "vertical";
  return Orientation;
}(Orientation || {});
var cssClasses = classNames.bind(styles);
var Spacer = function Spacer(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? Size.Regular : _ref$size,
    _ref$orientation = _ref.orientation,
    orientation = _ref$orientation === void 0 ? Orientation.Horizontal : _ref$orientation,
    testId = _ref.testId,
    as = _ref.as;
  var spacerClass = cssClasses(size, orientation);
  if (as === 'span') return /*#__PURE__*/jsx("span", {
    className: spacerClass,
    "data-testid": testId
  });
  return /*#__PURE__*/jsx("div", {
    className: spacerClass,
    "data-testid": testId
  });
};
Spacer.Size = Size;
Spacer.Orientation = Orientation;

export { Spacer as default };
//# sourceMappingURL=Spacer.js.map
